import { useBreakpoint, useIsMobile } from '@brg/ui'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { SuccessButtonsWrapper, SuccessInfo, SuccessMobileWrapper, SuccessText, SuccessTitle, SuccessWrapper, SummaryInfoWrapper } from '../PaymentSuccess/styles'
import { SummaryInfoList } from '../OrderSummary/SummaryInfoList'
import { PaymentButtonHollow, PaymentButtonSolid } from '../CheckOut/styles'
import { useAuth, useProfile } from '@brg/auth'
import { useHistory } from 'react-router-dom'
import {selectorOrder} from "../../slices/OrderSlice";
import { LayoutConst, useModal } from 'core'
import { useSelector } from 'react-redux'

interface urlIdType {
    id: string
    type: string
    source?: string
}


export interface PaymentParams {
    params: urlIdType
}

interface PaymentSuccessProps {
    text?: string
    hideTitle?: boolean
    hideSummary?: boolean
    hideGoToTransaction?: boolean
    onSummaryClick?: () => void
}

export const PaymentSuccess: FC<PaymentSuccessProps> = ({ text, hideTitle, hideGoToTransaction, onSummaryClick }) => {
    const { t } = useTranslation()
    const isMobile = useIsMobile()
    const is744 = useBreakpoint(LayoutConst.screen.s);
    const order = useSelector(selectorOrder);
    const modal = useModal()
    const profile = useProfile();
    const history = useHistory();
    const Auth = useAuth()

    const goToMain = () => {
        history.push('/')
        modal.hide()
    }

    const goToMyBooks = () => {
        if (!profile?.accountId) {
            Auth.login()
            return
        }
        history.push(`/mybooks`);
        modal.hide()
    }

    const mineButtonLabel = 'payment.to_my_books'
    const secondaryButtonLabel = 'payment.back_to_main'
    const primaryAction = goToMyBooks;
    const secondaryAction = goToMain;

    if (!is744) return (
        <SuccessWrapper>
            <SuccessTitle>{!hideTitle && t("payment.success")}</SuccessTitle>
            <SuccessText>{t("payment.payment_made")}</SuccessText>
            <SuccessInfo>
                <SummaryInfoWrapper onClick={onSummaryClick}>
                    <SummaryInfoList offsetBottom={24} offsetTop={0} paymentSuccess={true} />
                </SummaryInfoWrapper>
            </SuccessInfo>
            <SuccessButtonsWrapper centeredButtons={hideGoToTransaction}>
                {!hideGoToTransaction && <PaymentButtonHollow onClick={secondaryAction}>{t(secondaryButtonLabel)}</PaymentButtonHollow>}
                <PaymentButtonSolid onClick={primaryAction}>{t(mineButtonLabel)}</PaymentButtonSolid>
            </SuccessButtonsWrapper>
        </SuccessWrapper>
    )

    return (
        <SuccessMobileWrapper>
            <SuccessTitle mobile={isMobile}>{t("payment.success")}</SuccessTitle>
            <SuccessText>{t("payment.payment_made")}</SuccessText>
            <SuccessInfo>
                <SummaryInfoWrapper onClick={onSummaryClick}>
                    <SummaryInfoList offsetBottom={24} offsetTop={0} paymentSuccess={true} />
                </SummaryInfoWrapper>
            </SuccessInfo>
            <SuccessButtonsWrapper centeredButtons={hideGoToTransaction}>
                {!hideGoToTransaction && <PaymentButtonHollow onClick={secondaryAction}>{t(secondaryButtonLabel)}</PaymentButtonHollow>}
                <PaymentButtonSolid onClick={primaryAction}>{t(mineButtonLabel)}</PaymentButtonSolid>
            </SuccessButtonsWrapper>
        </SuccessMobileWrapper>
    )
}
import { useBreakpoint, useIsMobile } from '@brg/ui'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { SuccessButtonsWrapper, SuccessInfo, SuccessMobileWrapper, SuccessText, SuccessTitle, SuccessWrapper, SummaryInfoWrapper } from '../PaymentSuccess/styles'
import { SummaryInfoList } from '../OrderSummary/SummaryInfoList'
import { PaymentButtonHollow, PaymentButtonSolid } from '../CheckOut/styles'
import { useAuth, useProfile } from '@brg/auth'
import { useHistory } from 'react-router-dom'
import {selectorOrder} from "../../slices/OrderSlice";
import { LayoutConst, useModal } from 'core'
import { useSelector } from 'react-redux'

interface urlIdType {
    id: string
    type: string
    source?: string
}


export interface PaymentParams {
    params: urlIdType
}

interface PaymentSuccessProps {
    text?: string
    hideTitle?: boolean
    hideSummary?: boolean
    hideGoToTransaction?: boolean
    onSummaryClick?: () => void
}

export const PaymentSuccess: FC<PaymentSuccessProps> = ({ text, hideTitle, hideGoToTransaction, onSummaryClick }) => {
    const { t } = useTranslation()
    const isMobile = useIsMobile()
    const is744 = useBreakpoint(LayoutConst.screen.s);
    const order = useSelector(selectorOrder);
    const modal = useModal()
    const profile = useProfile();
    const history = useHistory();
    const Auth = useAuth()

    const goToMain = () => {
        history.push('/')
        modal.hide()
    }

    const goToMyBooks = () => {
        if (!profile?.accountId) {
            Auth.login()
            return
        }
        history.push(`/mybooks`);
        modal.hide()
    }

    const mineButtonLabel = 'payment.to_my_books'
    const secondaryButtonLabel = 'payment.back_to_main'
    const primaryAction = goToMyBooks;
    const secondaryAction = goToMain;

    if (!is744) return (
        <SuccessWrapper>
            <SuccessTitle>{!hideTitle && t("payment.success")}</SuccessTitle>
            <SuccessText>{t("payment.payment_made")}</SuccessText>
            <SuccessInfo>
                <SummaryInfoWrapper onClick={onSummaryClick}>
                    <SummaryInfoList offsetBottom={24} offsetTop={0} paymentSuccess={true} />
                </SummaryInfoWrapper>
            </SuccessInfo>
            <SuccessButtonsWrapper centeredButtons={hideGoToTransaction}>
                {!hideGoToTransaction && <PaymentButtonHollow onClick={secondaryAction}>{t(secondaryButtonLabel)}</PaymentButtonHollow>}
                <PaymentButtonSolid onClick={primaryAction}>{t(mineButtonLabel)}</PaymentButtonSolid>
            </SuccessButtonsWrapper>
        </SuccessWrapper>
    )

    return (
        <SuccessMobileWrapper>
            <SuccessTitle mobile={isMobile}>{t("payment.success")}</SuccessTitle>
            <SuccessText>{t("payment.payment_made")}</SuccessText>
            <SuccessInfo>
                <SummaryInfoWrapper onClick={onSummaryClick}>
                    <SummaryInfoList offsetBottom={24} offsetTop={0} paymentSuccess={true} />
                </SummaryInfoWrapper>
            </SuccessInfo>
            <SuccessButtonsWrapper centeredButtons={hideGoToTransaction}>
                {!hideGoToTransaction && <PaymentButtonHollow onClick={secondaryAction}>{t(secondaryButtonLabel)}</PaymentButtonHollow>}
                <PaymentButtonSolid onClick={primaryAction}>{t(mineButtonLabel)}</PaymentButtonSolid>
            </SuccessButtonsWrapper>
        </SuccessMobileWrapper>
    )
}
